import { ClassicEditor } from '@ckeditor/ckeditor5-editor-classic'
import editorConfig from './ckeditor'

$(function() {
  var editor = document.getElementById('notice_message_text')
  if (editor) ClassicEditor.create(editor, editorConfig)
})
